import { OCTTable } from "@oceantech/oceantech-ui";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { LichSuTheoDoiColumns } from "../constants/constant";
import { TruongHopBenh } from "../model/Model";
import { getThongTinTheoDoi } from "../servives/Services";
import { useIntl } from "react-intl";

const LichSuTheoDoi = () => {
    const { values } = useFormikContext<TruongHopBenh>()
    const [data, setdata] = useState([]);
    const intl = useIntl()
    const id = values?.truongHopBenh?.truongHopBenhId

    const getData = async () => {
        try {
            if (id) {
                const res = await getThongTinTheoDoi(id);
                setdata(res?.data?.data?.thbLichSuTheoDoi)
            }
            else {
                setdata([])
            }
        } catch (error) {
            console.error(error);
            toast.error(error as string);
        }
    }

    useEffect(() => {
        getData();
    }, [id])

    return (
            <div className="section-container">
                <span className="spaces fs-14 text-primary text-uppercase fw-bold">{intl.formatMessage({ id: "TRACKING_HISTORY" })},</span>
                <OCTTable
                    id="profile"
                    data={data}
                    columns={LichSuTheoDoiColumns(intl)}
                    fixedColumnsCount={0}
                    notDelete={true}
                    notEdit={true}
                    noToolbar={true}
                    unSelectedAll={true}
                    noPagination
                />
        </div>
    )
}

export default LichSuTheoDoi
